var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-repeat=\"formular in vm.formulare\" ng-attr-title=\"{{ formular.name }}\"><h5 ng-if=\"vm.canViewFormular(formular)\"><a href=\"{{ vm.getLink(formular) }}\"><span>{{ formular.name }}</span></a></h5></div>");;return buf.join("");
}